import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { GlobalService } from '../services/global.service';

export const commercialGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const globalService = inject(GlobalService);
  const router = inject(Router);
  const user = globalService.loggedUserClass;

  if (!authService.isLoggedin(user)) {
    router.navigate(['/login']);
    return false;
  }

  if (user?.Admin || user?.CommercialArea) {
    return true;
  }

  router.navigate(['/home']);
  return false;
};
